import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import JumboSelect from '../JumboSelect';
import ActivityCard from '../ActivityCard';

const ICON_ASSET = require('./icon.svg');

export default class ActivitySelect extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.props.handler.bind(this);
  }

  render() {
    return (
      <JumboSelect
        label="Interests"
        icon={ICON_ASSET}
        selected={this.props.value ? this.props.value.length : 0}
        modifier="interests"
        clear={this.props.clear}
      >
        {
          this.props.interests.map(interest => (
            <ActivityCard
              key={interest.id}
              id={interest.id}
              value={
                this.props.value && this.props.value.length > 0 &&
                this.props.value.find(interestID => interestID === interest.id)
              }
              activity={interest.title}
              label={interest.title}
              onSelect={this.handleSelect} />
          ))
        }
      </JumboSelect>
    );
  }
}

ActivitySelect.defaultProps = {
  value: [],
  handler: () => {},
  clear: () => {},
};

ActivitySelect.propTypes = {
  handler: PropTypes.func, //eslint-disable-line
  clear: PropTypes.func, //eslint-disable-line
  interests: PropTypes.array.isRequired,
  value: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/ActivitySelect/index.js